<template>
	<div class='knd-menu-svg'>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1419.32 986.19">
				<g id="Laag_2" data-name="Laag 2">
		<g id="Schijf">
			<g>
				<g id="cirkel">
					<circle class="cls-1" cx="743" cy="544" r="309"/>
				</g>
				<g class='schijf-onderwerpen'>
					<g class='schijf-onderwerp' id="online-leven" data-index='4'>
						<polygon class="cls-2" points="599.44 214.1 592.14 256.25 673.15 192.94 678.07 159.79 689.41 116.83 686.17 62.52 651.32 19.56 591.33 0.66 557 0 512 1 425.17 17.13 382.2 61.71 371.04 117.23 397.44 172.78 413.82 205.18 479.47 218.15 512.71 218.96 553.24 220.58 572.69 218.15 599.44 214.1"/>
						<path class="cls-1" d="M481.48,238.27c-2,3.56-38-36.1-38-36.1s-18.38-32.25-19.44-33.32.68-33.08,1.91-36.35,17.31-17.61,19.64-16.44,16.12,1.31,18.71,3.58,17.29,18.8,17.29,18.8,12.6-14.68,13.14-17.1,12.33-11.85,12.33-11.85L530,107.2s9.8,8.63,11,12.44,9.29,21.19,8.91,25-3.38,23.93-3.38,23.93S532.39,191.66,529,196.34s-21.18,19.13-21.18,19.13Z"/>
						<g>
							<circle class="cls-3" cx="572.5" cy="77.5" r="12.5"/>
							<circle class="cls-3" cx="606" cy="81" r="9"/>
							<circle class="cls-3" cx="634" cy="81" r="9"/>
						</g>
						<rect class="cls-4" x="300" y="266" width="500" height="90"/>
						<text class="cls-5" transform="translate(401.08 328.86)">het online leven</text>
					</g>
					<g class='schijf-onderwerp' id="portemonnee" data-index='0'>
						<g>
							<path class="cls-2" d="M1095.61,342.2s-.21-11.33,1.56-12.11,17-15.76,17-15.76l11.62-1.57,17.18,2.48L1157.71,331l4.71,19.5-8,18.82-23.68,8.06s-18-2.43-19.67-2.19-13.53-19.5-13.53-19.5Z"/>
							<rect class="cls-4" x="1034.98" y="355.57" width="188.86" height="101.4"/>
							<path class="cls-2" d="M1151.75,266.34s-.21-11.33,1.55-12.11,17-15.76,17-15.76l11.62-1.58,17.17,2.48,14.78,15.73,4.72,19.49-8,18.82-23.67,8.07s-17.95-2.43-19.67-2.2-13.53-19.5-13.53-19.5Z"/>
							<path class="cls-2" d="M1184.75,352.34s-.21-11.33,1.55-12.11,17-15.76,17-15.76l11.62-1.58,17.17,2.48,14.78,15.73,4.72,19.49-8,18.82-23.67,8.07s-17.95-2.43-19.67-2.2-13.53-19.5-13.53-19.5Z"/>
							<rect class="cls-2" x="1066.98" y="388.02" width="29" height="19"/>
						</g>
						<rect class="cls-3" x="874.98" y="431.02" width="500" height="90"/>
						<text class="cls-6" transform="translate(974.02 492.88)">je portemonnee</text>
					</g>
					<g class='schijf-onderwerp' id="thuis" data-index='1'>
						<g>
							<path class="cls-1" d="M1079,701.29s1.51-14.42,3.62-15.1,21.65-17.09,21.65-17.09h13.41l19.09,6.1,14.33,22.51,2.36,25.55-12,22.5-28.07,6.17s-20-6.17-22-6.17-12.34-27.08-12.34-27.08Z"/>
							<g>
								<path class="cls-2" d="M1178.36,688.89s1.13-10.83,2.72-11.34,16.25-12.83,16.25-12.83h10.07l14.33,4.58,10.76,16.9,1.77,19.18-9,16.89-21.08,4.63s-15-4.63-16.48-4.63-9.26-20.33-9.26-20.33Z"/>
								<path class="cls-1" d="M1164.4,782.62l-.11-21.22s1.83-17.6,4.42-18.43,26.42-20.85,26.42-20.85h16.36l23.3,7.44L1252.28,757l2.36,25.36"/>
							</g>
							<g>
								<path class="cls-3" d="M1259.36,698.89s1.13-10.83,2.72-11.34,16.25-12.83,16.25-12.83h10.07l14.33,4.58,10.76,16.9,1.77,19.18-9,16.89-21.08,4.63s-15-4.63-16.48-4.63-9.26-20.33-9.26-20.33Z"/>
								<path class="cls-2" d="M1245.4,792.62l-.11-21.22s1.83-17.6,4.42-18.43,26.42-20.85,26.42-20.85h16.36l23.3,7.44L1333.28,767l2.36,25.36"/>
							</g>
							<g>
								<path class="cls-1" d="M1319.94,719.21s1.47-14.11,3.54-14.78,21.18-16.71,21.18-16.71h13.11l18.67,6,14,22,2.3,25-11.73,22-27.46,6s-19.53-6-21.47-6S1320,736.22,1320,736.22Z"/>
								<path class="cls-1" d="M1301.75,841.33l-.14-27.65s2.38-22.93,5.75-24,34.43-27.16,34.43-27.16h21.32l30.35,9.7L1416.25,808l3.07,33"/>
							</g>
							<path class="cls-3" d="M1060.44,826.15l-.15-28.27s2.44-23.44,5.88-24.55,35.2-27.78,35.2-27.78h21.8l31,9.92,23.3,36.58,3.14,33.78"/>
						</g>
						<rect class="cls-4" x="874.64" y="804.19" width="500" height="90"/>
						<text class="cls-6" transform="translate(952.24 866.05)">thuis en op school</text>
					</g>
					<g class='schijf-onderwerp' id="buurt" data-index='2'>
						<path class="cls-1" d="M408.7,934.72s4.93-14.66,11.89-15.35S491.65,902,491.65,902h44l62.66,6.2,47,22.88,7.73,26-39.4,22.87-92.13,6.27s-65.55-6.27-72.06-6.27S409,952.4,409,952.4Z"/>
						<path class="cls-3" d="M634,820.49c-3.86-9.09-35.53-78-35.53-78s-67.2-23.17-71.83-23.17-61,40.17-61,40.17l-17,68,78,137.49L593.84,890S637.87,829.57,634,820.49Zm-91.14,27A30.13,30.13,0,1,1,573,817.4,30.12,30.12,0,0,1,542.86,847.52Z"/>
						<rect class="cls-2" x="104" y="838" width="500" height="90"/>
						<text class="cls-5" transform="translate(284.95 901.36)">je buurt</text>
					</g>
					<g class='schijf-onderwerp' id="lichaam" data-index='3'>
						<g>
							<polyline class="cls-10" points="53 611.04 72.93 593.47 98.39 583.06 131.45 566.38 156.23 547.73 175.91 529.59 180.76 509.99 183.32 482.57 180.76 469.05 173.86 430.7 175.91 403.87 183.32 381.48 194.05 368.61 209.13 352"/>
							<polyline class="cls-11" points="107.53 649.23 111.45 622.96 106.37 595.92 102.41 559.11 104.6 528.17 109.14 501.8 122.96 487.07 144.59 470.03 157.33 464.83 193.28 449.79 214.69 433.5 229.47 415.11 234.44 399.11 240.19 377.43"/>
						</g>
						<rect class="cls-3" y="535" width="500" height="90"/>
						<text class="cls-6" transform="translate(154.72 600.86)">je lichaam</text>
					</g>
				</g>
			</g>
		</g>
	</g>
		</svg>

	</div>
</template>

<script>
	import * as d3 from 'd3';

export default {

	name: 'menu-svg',

	computed: {
		themas () {
			return this.$store.state.themas;
		}
	},

	mounted() {
		d3.selectAll('.schijf-onderwerp')
			.on('click', (e, d) => {
				d3.selectAll('.schijf-onderwerp').classed('menu-inactive', true);

				let id = e.currentTarget.getAttribute('id');
				let index = +e.currentTarget.dataset.index;

				e.currentTarget.classList.remove('menu-inactive');
				
				if(id && index !== undefined) {
					this.$store.dispatch('updateSelection', {name:id, index})
				}
			})
	}

}
</script>